import React from 'react';
import {
  InfoCard, StructuredMetadataTable,
} from '@backstage/core-components';
import {
  Alert, Grid, List, ListItem, ListItemIcon, Tooltip,
} from '@mui/material';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Route53ZoneResourceEntity } from '@eng-portal/czi-extensions-common';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { omit } from 'lodash';
import { CardTitle } from './CardTitle';

export function Route53ZoneAboutCard(): JSX.Element {
  const { entity: zone } = useEntity<Route53ZoneResourceEntity>();
  if (!zone) {
    return <Alert severity="error">Zone not found</Alert>;
  }

  const {
    metadata: { name, title },
    spec,
  } = zone;

  const metadata: Record<string, any> = {
    ...omit(spec, 'type', 'owner', 'dependsOn'),
  };

  return (
    <InfoCard
      title={<CardTitle title={title || name} />}
    >
      <Grid container spacing={3} alignItems="flex-start">
        <Grid item md={10} xl={11}>
          <List>
            <ListItem>
              <ListItemIcon>
                <Tooltip title="Metadata">
                  <AccountTreeIcon />
                </Tooltip>
              </ListItemIcon>
              <StructuredMetadataTable metadata={metadata} />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </InfoCard>
  );
}
